import { application } from "./application"

// Shared controllers from @solrengine/wallet-utils
import { WalletController, AutoRefreshController } from "@solrengine/wallet-utils/controllers"
application.register("wallet", WalletController)
application.register("auto-refresh", AutoRefreshController)

// App-specific controllers
import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)
